import { useMutation } from "@tanstack/react-query";
import { queryClient } from "../../..";
import postImportCsv from "../queries/postImportCsv";

export default function usePostImportCsv(onSuccess: () => void) {
  return useMutation((value: any) => postImportCsv(value, () => onSuccess()), {
    onSuccess() {
      queryClient.invalidateQueries();
    },
    onError(err : Error) {
      console.log(err.message)
    }
  });
}
